import { API_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
};

const taxDetailsReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.SUCCESS: {
      return { ...state, loading: false, data: payload };
    }

    case API_EVENTS.FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default taxDetailsReducer;
